(() => {
  "use strict";
  
  const SELECTOR_ZOOM_CAPTION = "[data-zoom-caption]";
  const SELECTOR_ZOOM_IMAGE = "[data-zoom-image]";
  const SELECTOR_PSWP_THUMBS_TEMPLATE = "[data-pswp-thumbs-template]";
  const SELECTOR_SECTION_TYPE = "[data-section-type]";
  const SELECTOR_PSWP_THUMBS = ".pswp__thumbs";
  const CLASS_PRODUCT_IMAGES = "product-images";
  const CLASS_PRODUCT_COMPONENT = "product-component";
  const CLASS_IS_DRAGGING = "is-dragging";
  const CLASS_VARIANT_SOLDOUT = "variant--soldout";
  const CLASS_VARIANT_UNAVAILABLE = "variant--unavailable";
  const CLASS_PSWP_ZOOM_GALLERY = "pswp-zoom-gallery";
  const CLASS_PSWP_ZOOM_GALLERY_SINGLE = "pswp-zoom-gallery--single";
  const ATTR_IMAGE_SRC = "data-image-src";
  const ATTR_IMAGE_WIDTH = "data-image-width";
  const ATTR_IMAGE_HEIGHT = "data-image-height";

  class ZoomImages extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest(SELECTOR_SECTION_TYPE);
      this.images = this.querySelectorAll(SELECTOR_ZOOM_IMAGE);
      this.zoomCaptions = this.container.querySelector(SELECTOR_ZOOM_CAPTION);
      this.thumbsContainer = document.querySelector(SELECTOR_PSWP_THUMBS);
    }

    connectedCallback() {
      this.images.forEach((image, index) => {
        // Handle click event
        image.addEventListener("click", (event) => {
          event.preventDefault();
          
          if (!image.closest(CLASS_PRODUCT_IMAGES).classList.contains(CLASS_IS_DRAGGING)) {
            this.createZoom(index);
            window.a11y.lastElement = image;
          }
        });

        // Handle keyboard event (Enter key)
        image.addEventListener("keyup", (event) => {
          if (event.code === "Enter") {
            event.preventDefault();
            this.createZoom(index);
            window.a11y.lastElement = image;
          }
        });
      });
    }

    createZoom(index) {
      const thumbsTemplate = this.container.querySelector(SELECTOR_PSWP_THUMBS_TEMPLATE)?.innerHTML;
      let items = [];
      let imageCount = 0;

      this.images.forEach((image) => {
        const imageSrc = image.getAttribute(ATTR_IMAGE_SRC);
        imageCount += 1;

        items.push({
          src: imageSrc,
          w: parseInt(image.getAttribute(ATTR_IMAGE_WIDTH)),
          h: parseInt(image.getAttribute(ATTR_IMAGE_HEIGHT)),
          msrc: imageSrc
        });

        if (this.images.length === imageCount) {
          const colorScheme = this.getColorScheme();
          
          const options = {
            history: false,
            focus: false,
            index: index,
            mainClass: `${CLASS_PSWP_ZOOM_GALLERY}${imageCount === 1 ? ` ${CLASS_PSWP_ZOOM_GALLERY_SINGLE}` : ""}${colorScheme ? ` ${colorScheme}` : ""}`,
            showHideOpacity: true,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: true,
            closeEl: true,
            closeElClasses: ["caption-close", "title"],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 2,
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false,
            addCaptionHTMLFn: (item, captionEl, isFake) => {
              return this.zoomCaption(item, captionEl, isFake);
            },
            getThumbBoundsFn: () => {
              const thumbnail = this.images[index];
              const pageYScroll = window.scrollY || document.documentElement.scrollTop;
              const rect = thumbnail.getBoundingClientRect();
              
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          };

          new window.theme.LoadPhotoswipe(items, options);

          // Add thumbs if thumbsContainer exists and thumbsTemplate is not empty
          if (this.thumbsContainer && thumbsTemplate !== "") {
            this.thumbsContainer.innerHTML = thumbsTemplate;
          }
        }
      });
    }

    zoomCaption(item, captionEl, isFake) {
      let captionHTML = "";
      const captionContainer = captionEl.children[0];

      if (this.zoomCaptions) {
        captionHTML = this.zoomCaptions.innerHTML;
        
        // Handle sold out variant
        if (this.zoomCaptions.closest(`.${CLASS_VARIANT_SOLDOUT}`)) {
          captionContainer.classList.add(CLASS_VARIANT_SOLDOUT);
        } else {
          captionContainer.classList.remove(CLASS_VARIANT_SOLDOUT);
        }
        
        // Handle unavailable variant
        if (this.zoomCaptions.closest(`.${CLASS_VARIANT_UNAVAILABLE}`)) {
          captionContainer.classList.add(CLASS_VARIANT_UNAVAILABLE);
        } else {
          captionContainer.classList.remove(CLASS_VARIANT_UNAVAILABLE);
        }
      }
      
      captionContainer.innerHTML = captionHTML;
      return false;
    }

    getColorScheme() {
      const productComponent = this.closest(CLASS_PRODUCT_COMPONENT);
      return Array.from(productComponent.classList).find(className => 
        className.startsWith("color-scheme")
      );
    }
  }

  if (!customElements.get("zoom-images")) {
    customElements.define("zoom-images", ZoomImages);
  }
})();
